import React from "react";
import "../styles/contact.css";

const Contact = props => (
  <main style={{...props.style}}>
    <div className="sub-section contact">
      <ul>
        <li>
          I do email here: <span>btbright@[googlemail]</span>
        </li>
        <li>
          I do tweets here:{" "}
          <a
            href="https://twitter.com/btbright"
            target="_blank"
            rel="noopener noreferrer"
          >
            twitter.com/btbright
          </a>
        </li>
        <li>
          I do code here:{" "}
          <a
            href="https://github.com/btbright"
            target="_blank"
            rel="noopener noreferrer"
          >
            github.com/btbright
          </a>
        </li>
      </ul>
    </div>
  </main>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/Contact.js